export default class OpenAPINetworkError {
  response: { data: any, status: number}

  constructor(response: { data: any, status: number }) {
    this.response = response
  }
}